import { InjectionToken, Type } from '@angular/core';

import { SliceWithData } from '../../../typings';
import { SliceType } from '@repo/shared';

export type SliceComponentClass = Type<SliceWithData>;
export type SliceComponentClassMap = Record<SliceType, SliceComponentClass>;

export const SLICE_COMPONENT_CLASS_MAP = new InjectionToken<SliceComponentClassMap>('SLICE_COMPONENT_CLASS_MAP');
